var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivechatGreyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161035",
    "data-name": "Group 161035",
    transform: "translate(-218.386 -263.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160723",
    "data-name": "Group 160723",
    transform: "translate(218.386 263.519)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#a6a8bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline",
    d: "M58.6,64H49.649A1.654,1.654,0,0,0,48,65.649V71.3a1.654,1.654,0,0,0,1.649,1.649h1.178v2.356l2.76-2.3a.236.236,0,0,1,.151-.055H58.6A1.654,1.654,0,0,0,60.251,71.3V65.649A1.654,1.654,0,0,0,58.6,64Z",
    transform: "translate(-42.857 -58.075)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161034",
    "data-name": "Group 161034"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(225.434 272.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(228.633 272.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_290",
    "data-name": "Ellipse 290",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(231.832 272.893)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechatGreyIcon);
export default __webpack_public_path__ + "static/media/livechat-grey-icon.310607ad06b0435d40fad42a6397a018.svg";
export { ForwardRef as ReactComponent };